export default {
  init() {
    // JavaScript to be fired on the single Workshop page
    },
  finalize() {
      const occupation_value = $('#occupation').val(); // get the dropdown value
      if(occupation_value == 'other (occupation not listed)'){
        $(".occupation_others_div").removeClass('d-none');
      }
      // change the occupation events
      $('#occupation').on('change', function () {
        const occupation_value = $(this).val(); // get the dropdown value
        $(".occupation_others_div").addClass('d-none'); // by default others field hide
        //BIZ_823 START: Making occupation_others element null only if profilevalidation
        var profileValidationClick = $(".profileValidation");
        if(!profileValidationClick.data('clicked')) {
          $("#occupation_others").val('');
        }
        //BIZ_823 START: Making occupation_others element null only if profilevalidation
        if(occupation_value == 'other (occupation not listed)'){
          $(".occupation_others_div").removeClass('d-none');
        }
      });
      
      /* START: BIZ-277 add userid if other training program added */
      const logged_hidden_id = $("#logged_hidden_id").val();
      $( ".workshop-other-training-option" ).each(function() {
        const anchorLink = $(this).find('a').attr('href');
        if(anchorLink.includes("uow.au1.qualtrics.com") || anchorLink.includes("?workshop_id=") ){
          const newAnchorLink = anchorLink +"&user_id="+logged_hidden_id;
          $(this).find('a').attr('href',newAnchorLink);
        }
      });
      /* END: BIZ-277 add userid if other training program added */

      /* START: BIZ-878 toggle for password field hidden to showing*/
      const toggle_password_block = $("#workshop_toggle_password_icon");
      const toggle_icon = $("#workshop_toggle_password_icon i");
      const password_field = $("#workshop_password_field");
      toggle_password_block.on("click", () => {
        if(password_field.attr("type") === "password"){
          password_field.attr("type", "text")
          toggle_icon.removeClass("fa-eye-slash");
          toggle_icon.addClass("fa-eye");
          return;
        }
        password_field.attr("type", "password");
        toggle_icon.removeClass("fa-eye");
        toggle_icon.addClass("fa-eye-slash");
      })
      /* END: BIZ-878 toggle for password field hidden to showing */
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/single-workshop.js